const canUserSeeThis = (accessStringToCheck) => {
  try {
    const userLoginDetailsArray = JSON.parse(
      localStorage.getItem("currentUser"),
    );
    if (
      !Array.isArray(userLoginDetailsArray) ||
      !userLoginDetailsArray[0] ||
      typeof userLoginDetailsArray[0].useraccess !== "string"
    ) {
      return false;
    }
    const userAccessString = userLoginDetailsArray[0].useraccess;
    return userAccessString.indexOf(accessStringToCheck) !== -1;
  } catch (e) {
    return false;
  }
};
export default canUserSeeThis;
